import { Navigate, Route, Routes } from "react-router-dom";
import { useAuthBootstrap } from "@/hooks/useAuth";
import { useAuthStore } from "@/store/authStore";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import FunnelBoard from "@/pages/FunnelBoard";
import OpportunityDetail from "@/pages/OpportunityDetail";
import Assembly from "@/pages/Assembly";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  const { ready } = useAuthBootstrap();
  if (!ready) {
    return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        element={
          <RequireAuth>
            <Layout />
          </RequireAuth>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/funnels/:key" element={<FunnelBoard />} />
        <Route path="/opportunities/:id" element={<OpportunityDetail />} />
        <Route path="/assembly" element={<Assembly />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
